import { InputAdornment } from "@mui/material";
import { SpecsImageUploadTrigger } from "./SpecsImageUploadTrigger";

// Tiny icon shown at the right side of specs editor image inputs to trigger image uploads.
export function SpecsImageUploadAdornment({
  onUpload,
  uploading,
  onOpenFilePicker,
  accept,
}: {
  onUpload: (file: File) => void | Promise<void>;
  uploading: boolean;
  onOpenFilePicker?: () => void;
  accept?: string;
}) {
  return (
    <InputAdornment position="end" sx={{ ml: 0.25 }}>
      <SpecsImageUploadTrigger
        onUpload={onUpload}
        uploading={uploading}
        onOpenFilePicker={onOpenFilePicker}
        variant="icon"
        accept={accept}
      />
    </InputAdornment>
  );
}
